import { connect } from "react-redux";

import SavedSearchBox from "../components/saved_search_box";
import { savedSearchOptionsTrigger, downloadSavedSearchTrigger, savedSearchSubmitTrigger } from "../actions/data_hub_search";

const mapStateToProps = (state) => {
  const searchSelected = !!state.dataHubSearch.selectedSavedSearch;
  const disableSaveSearchButton = searchSelected || !!state.loading.showLoadingOverlay;
  const disableDownloadButton = !!state.loading.showLoadingOverlay;

  return { disableSaveSearchButton, disableDownloadButton, searchSelected };
};

const mapDispatchToProps = dispatch => ({
  onSaveSearchClick: () => dispatch(savedSearchOptionsTrigger()),
  onDownloadClick: () => dispatch(downloadSavedSearchTrigger()),
  downloadLoadedSearch: () => dispatch(savedSearchSubmitTrigger(true))
});

export default connect(mapStateToProps, mapDispatchToProps)(SavedSearchBox);
